export const API_URL = process.env.REACT_APP_API_URL as string;
export const REFRESH_TOKEN_URL = `${API_URL}/auth/refresh`;

export const getConfigurationAssetUrl = (
  friendly_url: string,
  module: string,
  type: string,
  id: string
): string =>
  `${API_URL}/ehs-visitor-management/${friendly_url}/${module}/configuration/${type}/${id}`;
